<template>
  <section>
    <div class="is-flex is-align-items-center is-justify-content-flex-end">
      <p
        class="m-l-10 has-text-weight-semibold has-text-grey is-size-2 is-strikethrough"
        :data-e2e="EstateCypressAttribute.standardPlan.views.PRICE"
      >
        {{ billingPlan.formattedFinalPrice }}
      </p>
      <p class="m-l-10 has-text-weight-semibold is-size-1">{{ $t('financial-advisor-free') }}</p>
    </div>
    <p class="is-flex">
      {{ $t('financial-advisor-no-charge-with-advisor') }}
      <img class="ml-2" src="@/assets/illustrations/nav/advisor-pro-badge.svg" />
    </p>
  </section>
</template>

<script>
import { SelfServeBillingPlanForm } from '@/modules/estate/models/SelfServeBillingPlanForm';
import { EstateCypressAttribute } from '/@/modules/estate/constants/EstateCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'VaultFreePlanPriceView',
  props: {
    billingPlan: {
      type: SelfServeBillingPlanForm,
      required: true
    }
  },
  static: {
    EstateCypressAttribute
  }
};
</script>
